import styled from "styled-components";

export const Controls = styled.div`
  gap: 6px;
  width: 100%;
  display: flex;
  flex-direction: column;

  & > span {
    color: ${(props) => props.theme.colors.errored100};
    font-size: 1.2rem;
    font-weight: 700;
  }
`;
